import React from 'react';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

import CONSTANT from './../../../constant';
import Header from '../../../component/common/AdminHeader';
import Paging from '../../../component/common/Paging';
import UserList from './../../../component/user/List';
import UserSearchBar from './../../../component/user/UserSearchBar';
import Loader from './../../../component/common/Loader';
import { getUserList } from './../../../actions/UserAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            page: 1,
            limit: 50,
            list: undefined,
            count: 0,
            showLoader: false
        }
    }

    componentDidMount() {
        
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { page, list, showLoader } = this.state;
        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="page-title">All Users</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Link to={CONSTANT.component.adminAddUser.url} className="btn btn-sm submit-button d-inline-block mr-3">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Add Employee
                                    </Link>
                                    <Link to={CONSTANT.component.adminUploadUserExcel.url} className="btn btn-sm submit-button d-inline-block mr-3">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Upload Excel
                                    </Link>
                                    <button onClick={this.downloadExcel} className="btn btn-sm submit-button d-inline-block">
                                        <i className="fa fa-download mr-2" />
                                        Download Excel
                                    </button>
                                </div>
                                <div className="col-md-6">
                                    <UserSearchBar />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className="table-container">
                                            <div className="table-wrapper radius-4">
                                                <UserList list={list} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                list !== undefined && <Paging page={page} listItem={list} onPageChange={this.changePage} />
                            }
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>

            
        )
    }

    loadList = () => {
        const { page, limit } = this.state;
        getUserList(page, limit).then((res: any) => {
            this.setState({ list: res.result.list, count: res.result.count });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }

    downloadExcel = (e: any) => {
        this.setState({ showLoader: true });
        const { count } = this.state;
        getUserList(1, count).then((res: any) => {
            this.setState({ showLoader: false });
            let date = new Date();
            let filename = `report-${date.getTime()}.xlsx`;

            let dataToExport: any = [];
            var ws_name = "Sheet1";
            res.result.list.map(function (item: any) {
                delete item.code;
                delete item.modifiedOn;
                delete item.userTypeName;
                delete item.loginStatusName;

                dataToExport.push({
                    ...item,
                });
            });
            var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(dataToExport);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);
            XLSX.writeFile(wb, filename);
        });
    }
}

export default ComponentName;